<template>
  <div class="card-traceability">
    <card
      v-if="card.visible"
      :id="card.id"
      :key="card.id"
      :title="card.title"
      :capitalize-subtitle="card.capitalizeSubtitle"
      :transparent-card="card.transparentCard"
      :subtitle-regular="getUpdateTime.phrase"
      :subtitle-highlight="getUpdateTime.time + ' (Período 7 dias)'"
      :buttons="card.buttons"
      :class="[{ 'card-disabled': card.disabled }, card.class]"
      @btnClickAction="!card.disabled && go(card.buttons[0].action)"
    >
      <div>
        <div class="wrapper">
          <img
            src="/static/images/tubos.svg"
            alt="icone-tubos"
          />
          <div>
            <p class="title">total de lotes</p>
            <div class="value-group">
              <p class="value batch">
                {{ totalBatches }}
              </p>

              <p
                v-if="totalExamsLabel"
                class="value-detail"
              >
                {{ totalExamsLabel }}
              </p>
            </div>
          </div>
        </div>
        <div class="wrapper">
          <img
            src="/static/images/caminhao.svg"
            alt="icone-caminhao"
          />
          <div>
            <p class="title">lotes Aguardando retirada</p>
            <div class="value-group">
              <p class="value batch-waiting">
                {{ batchesWaitingForTransport }}
              </p>

              <p
                v-if="waitingExamsLabel"
                class="value-detail"
              >
                {{ waitingExamsLabel }}
              </p>
            </div>
          </div>
        </div>
        <div class="wrapper">
          <img
            src="/static/images/caminhao-amostras.svg"
            alt="icone-caminhao-amostras"
          />
          <div>
            <p class="title">lotes Em trânsito</p>
            <div class="value-group">
              <p class="value batch-in-transit">
                {{ batchesInTransit }}
              </p>

              <p
                v-if="inTransferExamsLabel"
                class="value-detail"
              >
                {{ inTransferExamsLabel }}
              </p>
            </div>
          </div>
        </div>
        <div class="wrapper">
          <img
            src="/static/images/predio.svg"
            alt="icone-predio"
          />
          <div>
            <p class="title">lotes Em trânsito entre Ntos</p>
            <div class="value-group">
              <p class="value batch-in-transit-nto">
                {{ batchesInTransitNTOs }}
              </p>

              <p
                v-if="inTransferBetweenNTOExamsLabel"
                class="value-detail"
              >
                {{ inTransferBetweenNTOExamsLabel }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import moment from 'moment'

import Card from '../Card'
import batchService from '@/api/batch'

const EXCLUDED_TOTAL_EXAM_STATUSES = [
  'AMOSTRA_OBTIDA',
  'CANCELADO_CLIENTE',
  'PENDENCIA_CRIADA',
  'PENDENCIA_RESPONDIDA',
  'EM_TRANSITO_ENTRE_NTO',
  'RECOLETADO',
  'SOLICITADA_RECOLETA',
  'ATRASADO',
  'EM_LIBERACAO',
  'ADIANTADO',
]

export default {
  name: 'CardTraceability',
  components: { card: Card },
  data() {
    return {
      totalBatches: 0,
      groupedExamsCount: {},
      batchesWaitingForTransport: 0,
      batchesInTransit: 0,
      batchesInTransitNTOs: 0,
    }
  },
  computed: {
    ...mapGetters(['getUpdateTime', 'toggle']),
    card() {
      return {
        id: 'traceability',
        visible: true,
        disabled: !this.toggle.sampleTraceability,
        title: 'Rastreabilidade - logística',
        class: 'logistic',
        buttons: [
          {
            text: 'ACESSAR DETALHES',
            style: 'btn-primary',
            action: '/traceability/logistic/batches',
            visible: !this.toggle.covax && this.toggle.results,
          },
        ],
      }
    },
    totalExamsCount() {
      if (!Object.keys(this.groupedExamsCount).length) {
        return undefined
      }

      return Object.keys(this.groupedExamsCount)
        .filter(key => !EXCLUDED_TOTAL_EXAM_STATUSES.includes(key))
        .reduce((total, key) => total + (this.groupedExamsCount[key] || 0), 0)
    },
    totalExamsLabel() {
      return this.formatExamsLabel(this.totalExamsCount)
    },
    waitingExamsLabel() {
      return this.formatExamsLabel(this.groupedExamsCount.CADASTRADO)
    },
    inTransferExamsLabel() {
      return this.formatExamsLabel(this.groupedExamsCount.EM_TRANSITO)
    },
    inTransferBetweenNTOExamsLabel() {
      return this.formatExamsLabel(this.groupedExamsCount.EM_TRANSITO_ENTRE_NTO)
    },
  },
  mounted() {
    this.fetchBatchData()
  },
  methods: {
    fetchBatchData() {
      const filter = {
        startDate: moment(new Date()).subtract(7, 'days').format('YYYY-MM-DD'),
        endDate: moment(new Date()).format('YYYY-MM-DD')
      }

      batchService.getBatchStatus(filter).then(response => {
        const { total, waiting, inTransfer, inTransferBetweenNTO } = response.data
        this.batchesWaitingForTransport = waiting
        this.totalBatches = total
        this.batchesInTransit = inTransfer
        this.batchesInTransitNTOs = inTransferBetweenNTO
      })

      batchService.getGroupedExamsCount(this.getGroupedExamsCountFilter(filter)).then(response => {
        this.groupedExamsCount = response.data ?? {}
      })
    },
    getGroupedExamsCountFilter(filter) {
      const endDate = moment(filter.endDate).add(1, 'days').format('YYYY-MM-DD')

      return {
        filterType: 'periodo',
        filterValue: `${filter.startDate}/${endDate}`,
        status: '',
      }
    },
    formatExamsLabel(value) {
      if (value === undefined || value === null) {
        return ''
      }

      const label = value === 1 ? 'exame' : 'exames'

      return `${value} ${label}`
    },
    go(path) {
      this.$router.push({
        path: path,
        query: {
          startDate: moment(new Date()).clone().subtract(7, 'days').format('YYYY-MM-DD'),
          endDate: moment(new Date()).format('YYYY-MM-DD')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .card-traceability {
    flex: 1;
  }
}

@media (max-width: 1024px) {
  .card-traceability {
    margin: 20px 0;

    .md-card {
      padding-bottom: 20px;
    }
  }
}

.wrapper {
  margin-top: 24px;

  .title {
    text-transform: uppercase;
    font-size: 11px;
    font-weight: 600;
    margin: 0;
    line-height: 0;
    color: #818181;
  }

  .value {
    font-size: 27px;
    font-weight: 600;
    margin-top: 12px;
  }

  .value-group {
    display: flex;
    gap: 6px;
    align-items: baseline;
    flex-wrap: wrap;
  }

  .value-detail {
    font-size: 13px;
    font-weight: 600;
    margin: 0;
    color: #818181;
    white-space: nowrap;
  }

  .batch {
    color: #00b5cc;
  }

  .batch-waiting {
    color: #f78e26;
  }

  .batch-in-transit {
    color: #52cc9c;
  }

  .batch-in-transit-nto {
    color: #8ad4df;
  }

  img {
    margin-right: 8px;
  }
}

.logistic {
  .graphic-legend {
    overflow-y: scroll;
    height: 235px;
    width: 100% !important;
    margin-left: 40px !important;
  }

  .count-indicator__count {
    &.count-indicator__count--bigger {
      p {
        font-size: 24px;
      }
    }
  }

  .count-indicator__description--bigger {
    width: 100% !important;
  }
}
</style>
